import { RAN_DB_BULK_REVIEW } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const reviewBulkAddUploadDeleteSites = async (ranDbObj) => {
  try {
    const response = await apiClient.post(RAN_DB_BULK_REVIEW, ranDbObj);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
